
const hasAccess = (requiredPermissions) => {
  const { permissions: userPermissions } = window.authorizationClaims

  const missingPermissions =
    requiredPermissions.filter(permission => !userPermissions.includes(permission))

  return missingPermissions.length === 0
}

export default hasAccess
